import { render, staticRenderFns } from "./SeniorHouseOffice.vue?vue&type=template&id=70548ef7&scoped=true"
import script from "./SeniorHouseOffice.vue?vue&type=script&lang=js"
export * from "./SeniorHouseOffice.vue?vue&type=script&lang=js"
import style0 from "./SeniorHouseOffice.vue?vue&type=style&index=0&id=70548ef7&prod&lang=scss&scoped=true"
import style1 from "./SeniorHouseOffice.vue?vue&type=style&index=1&id=70548ef7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70548ef7",
  null
  
)

export default component.exports